import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d1e92b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "organization-info"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  target: "_blank",
  href: "https://chatcaptain.de/support/"
}, "Weitere Informationen", -1))
const _hoisted_3 = { class: "button-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "link-wrapper" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com",
    target: "_blank"
  }, "Impressum"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chatcaptain.com",
    target: "_blank"
  }, "Datenschutz")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_card = _resolveComponent("md-card")!

  return (_openBlock(), _createBlock(_component_md_card, {
    variant: "elevated",
    class: "user-profile"
  }, {
    default: _withCtx(() => [
      (_ctx.organization)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createTextVNode(" Dieses Konto wird durch "),
            _createElementVNode("b", null, _toDisplayString(_ctx.organization), 1),
            _createTextVNode(" verwaltet. "),
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("h2", null, _toDisplayString(_ctx.user.displayName), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.user.email), 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_md_button, { variant: "tonal" }, {
          default: _withCtx(() => [
            _createTextVNode("Konto verwalten")
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_md_button, {
        variant: "text",
        onClick: _ctx.signOut
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abmelden")
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_4,
      _hoisted_5
    ]),
    _: 1
  }))
}